import { useOidcUser } from '@axa-fr/react-oidc'
import { useAppSelector } from '../../redux/_reduxHooks'
import { OidcUserRoleInfo } from '../../types/global/OidcUserRoleInfo'
import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import React, { FC } from 'react'

interface Props {
  style?: React.CSSProperties
}

export const BuyNowButton: FC<Props> = ({style}) => {
  const { oidcUser } = useOidcUser<OidcUserRoleInfo>()

  // @ts-ignore
  const userRoles = oidcUser?.role

  const webTopicData = useAppSelector((state) => state.web.selectedNwTopic)

  const handleRedirectUser = () => {
    const anmeldeUrl = window.location.origin + `/anmeldung/${webTopicData?.thmCode}/${webTopicData?.seminarList[0].id}`

    window.location.href = anmeldeUrl
  }

  return (
    <ButtonComponent type={'button'} isPrimary style={style} title={`Videoaufzeichnung "${webTopicData?.thmKurz}" jetzt kaufen.`} onClick={handleRedirectUser}>
      Lizenzen erwerben
    </ButtonComponent>
  )
}
